<template>
  <p>{{ profileEmail }}</p>
</template>

<script>
export default {
  props: ["profileEmail"]
};
</script>
